import { Component, OnInit, ViewChild } from '@angular/core';
import { DesktopSidebarComponent } from "../../../../shared/components/desktop-sidebar/desktop-sidebar.component";
import { DesktopTopbarComponent } from "../../../../shared/components/desktop-topbar/desktop-topbar.component";
import { MobileTopbarComponent } from "../../../../shared/components/mobile-topbar/mobile-topbar.component";
import { TabButtonComponent } from "../../../../shared/components/tab-button/tab-button.component";
import { CustomDropdownComponent } from "../../../../shared/components/custom-dropdown/custom-dropdown.component";
import { ComparisonYearComponent } from "../../components/comparison-year/comparison-year.component";
import { GasCostsChartComponent } from "../../charts/gas/gas-costs-chart/gas-costs-chart.component";
import { GasConsumptionChartComponent } from "../../charts/gas/gas-consumption-chart/gas-consumption-chart.component";
import { GasConsumptionQuartalChartComponent } from "../../charts/gas/gas-consumption-quartal-chart/gas-consumption-quartal-chart.component";
import { GasCostAnalysisChartComponent } from "../../charts/gas/gas-cost-analysis-chart/gas-cost-analysis-chart.component";
import { GasCostPerSmcChartComponent } from "../../charts/gas/gas-cost-per-smc-chart/gas-cost-per-smc-chart.component";
import { GasCostBreakdownChartComponent } from "../../charts/gas/gas-cost-breakdown-chart/gas-cost-breakdown-chart.component";
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { CustomFooterComponent } from "../../../../shared/components/custom-footer/custom-footer.component";
import { SubscriptionService } from '../../../../core/services/subscription.service';
import { LocationService } from '../../../../core/api/location.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { Location } from '../../../../core/interfaces/location';
import { GasConsumptionAndCosts, GasPeriodCostAnalysisGet, YearlyOverview } from '../../../../core/interfaces/dashboard-interfaces';
import { DashboardService } from '../../../../core/api/dashboard.service';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { GasCostsAveragesComponent } from "../../charts/gas/gas-costs-averages/gas-costs-averages.component";
import { CommonModule } from '@angular/common';
import { combineLatest, Subscription } from 'rxjs';
import { UserDataService } from '../../../../core/services/user-data.service';
import { CompleteEnergyProfileComponent } from "../../components/overview/complete-energy-profile/complete-energy-profile.component";
import { FlexUpgradeComponent } from "../../components/flex-upgrade/flex-upgrade.component";
import { NoMembershipPopupComponent } from "../../../../shared/components/no-membership-popup/no-membership-popup.component";
import { NoDataMessageComponent } from "../../components/no-data-message/no-data-message.component";
import { ExtractionOngoingPopupComponent } from '../../../../shared/components/extraction-ongoing-popup/extraction-ongoing-popup.component';
import { CommodityType } from '../../../../core/interfaces/invoice-interfaces';
import { FileExtractionService } from '../../../../core/services/file_extraction_service';

@Component({
  selector: 'app-gas',
  standalone: true,
  imports: [DesktopSidebarComponent, DesktopTopbarComponent, MobileTopbarComponent, TabButtonComponent, CustomDropdownComponent, ComparisonYearComponent, GasCostsChartComponent, GasConsumptionChartComponent, GasConsumptionQuartalChartComponent, GasCostAnalysisChartComponent, GasCostPerSmcChartComponent, GasCostBreakdownChartComponent, TranslocoPipe, CustomFooterComponent, ToastComponent, FormsModule, CalendarModule, GasCostsAveragesComponent, CommonModule, CompleteEnergyProfileComponent, FlexUpgradeComponent, NoMembershipPopupComponent, NoDataMessageComponent, ExtractionOngoingPopupComponent],
  templateUrl: './gas.component.html',
  styleUrl: './gas.component.css'
})
export class GasComponent implements OnInit {
  get hasPlusSubscription(): boolean {
    return this.subscriptionService.hasPlusSubscription();
  }

  currentYear = new Date().getFullYear();

  get showUpgradeGasCosts(): boolean {
    if (this.gasCostsDataYear < this.currentYear) {
      return false;
    }
    return this.subscriptionService.showForecastUpgradeComponents();
  }

  get showUpgradeConsumption(): boolean {
    if (this.consumptionAndCostsDataYear < this.currentYear) {
      return false;
    }
    return this.subscriptionService.showForecastUpgradeComponents();
  }

  get showUpgradeGeneral(): boolean {
    return this.subscriptionService.showForecastUpgradeComponents();
  }

  get showDummyData(): boolean {
    return (!this.subscriptionService.hasPlusSubscription() || !this.userData.getUser()?.company?.has_files);
  }

  get isExtractionOngoing(): boolean {
    return this.fileExtractionService.isExtractionOngoing();
  }

  // Show no data dialog
  noDataDialogShowCosts: boolean = false;
  noDataDialogShowConsumptionCosts: boolean = false;

  // Dropdown Menu
  locationsDropdownOptions: string[] = [];
  selectedLocationDropdown: number | undefined;

  listOfLocations: Location[] = [];
  allLocationsTranslation: string = "All Locations";

  // Forecast max date
  gasForecastMaxDate: Date = new Date();

  // Gas costs date
  gasCostsDate: Date | undefined = new Date();
  gasCostsComparisonDate: Date | undefined = undefined;

  gasCostsDataResponse: YearlyOverview | null = null;
  gasCostsDataLoaded: boolean = false;
  gasCostsDataYear: number = 0;

  gasCostsComparisonDataResponse: YearlyOverview | null = null;
  gasCostsComparisonDataLoaded: boolean = false;
  gasCostsComparisonDataYear: number = 0;

  averagePricePerSmcData: (number | null)[] = new Array(12).fill(null);
  forecastedStartMonth: number | null = null;
  invoiceAmountActualData: (number | null)[] = new Array(12).fill(0);
  invoiceAmountForecastData: (number | null)[] = new Array(12).fill(0);

  compariosonCurrentyear: number = new Date().getFullYear();
  compariosonCurrentlastFullMonthCost: number = 0;
  compariosonCurrentlastFullMonthSmc: number = 0;
  compariosonCurrentyearToDateCost: number = 0;
  compariosonCurrentyearToDateSmc: number = 0;
  compariosonCurrentforecastFullYearCost: number = 0;
  compariosonCurrentforecastFullYearSmc: number = 0;

  compariosonOlderyear: number = (new Date().getFullYear() - 1);
  compariosonOlderlastFullMonthCost: number = 0;
  compariosonOlderlastFullMonthSmc: number = 0;
  compariosonOlderyearToDateCost: number = 0;
  compariosonOlderyearToDateSmc: number = 0;
  compariosonOlderforecastFullYearCost: number = 0;
  compariosonOlderforecastFullYearSmc: number = 0;

  // Consumption and costs
  consumptionAndCostsDate: Date | undefined = new Date();
  consumptionAndCostsDataResponse: GasConsumptionAndCosts | null = null;
  consumptionAndCostsDataLoaded: boolean = false;
  consumptionAndCostsDataYear: number = 0;

  cacl_consumption: (number | null)[] = new Array(12).fill(null);
  cacl_consumptionForecasted: (number | null)[] = new Array(12).fill(null);
  cacl_costsPerSmc: (number | null)[] = new Array(12).fill(null);
  cacl_costsPerSmcForecastedStartMonth: number | null = null;
  cacl_totalCost: (number | null)[] = new Array(12).fill(null);
  cacl_totalCostForecastedStartMonth: number | null = null;

  smcQuarterData: number[] = [0, 0, 0, 0];

  // Cost analysis
  costAnalysisYear: Date | undefined = new Date();
  costAnalysisMonth: Date | undefined = undefined;

  costAnalysisDataResponse: GasPeriodCostAnalysisGet | null = null;
  costAnalysisDataLoaded: boolean = false;
  costAnalysisDataYear: number = 0;
  costAnalysisDataMonth: number | null = null;

  costAnalysisPervoiusPeriodDataResponse: GasPeriodCostAnalysisGet | null = null;
  costAnalysisPervoiusPeriodDataLoaded: boolean = false;
  costAnalysisPervoiusPeriodDataYear: number = 0;
  costAnalysisPervoiusPeriodDataMonth: number | null = null;

  months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  capd_lineCostTrendData: number[] = [0, 0];
  capd_barSmcData: number[] = [0, 0];
  capd_inputedPeriods: string[] | undefined = undefined;
  capd_SmcDifference: number = 0;
  capd_costDifference: number = 0;

  materialCostsDifferenceSign: string = '+';
  materialCostsDifference: number = 0;
  fixedCostsDifferenceSign: string = '+';
  fixedCostsDifference: number = 0;
  tmsDifferenceSign: string = '+';
  tmsDifference: number = 0;
  additionalChargesDifferenceSign: string = '+';
  additionalChargesDifference: number = 0;
  taxesDifferenceSign: string = '+';
  taxesDifference: number = 0;
  previousPeriodCostPerSmc: number = 0;
  currentPeriodCostPerSmc: number = 0;
  inputedPeriods: string[] | undefined = undefined;

  noDataPopUp: boolean = false;

  costBreakdownData: number[] = new Array(5).fill(0);
  totalPricePerUnit: number = 0;

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // Minimum year for year pickers
  datePickerMinYear: Date = new Date(2024, 0, 1);

  extractionCompletedSubscription?: Subscription;

  constructor(private translocoService: TranslocoService, private subscriptionService: SubscriptionService, private locationService: LocationService, private apiError: ApiErrorService, private dashboardService: DashboardService, private userData: UserDataService, private fileExtractionService: FileExtractionService) { }

  ngOnInit(): void {
    this.translocoService.selectTranslate('dashboard.all_locations').subscribe((translation) => {
      this.locationsDropdownOptions = [translation];
      this.allLocationsTranslation = translation;
    });
    this.selectedLocationDropdown = 0;

    const monthKeys = [
      'shared.months.jan', 'shared.months.feb', 'shared.months.mar',
      'shared.months.apr', 'shared.months.may', 'shared.months.jun',
      'shared.months.jul', 'shared.months.aug', 'shared.months.sep',
      'shared.months.oct', 'shared.months.nov', 'shared.months.dec'
    ];

    combineLatest(monthKeys.map((key) => this.translocoService.selectTranslate(key)))
      .subscribe((translations) => {
        this.months = translations;
      });

    this.refreshDashboardData()

    this.fileExtractionService.startCheckingExtractionStatus(CommodityType.gas);

    this.extractionCompletedSubscription = this.fileExtractionService
      .onExtractionCompleted()
      .subscribe(() => {
        this.refreshDashboardData();
      });
  }

  refreshDashboardData(): void {
    this.loadLocationsData();
    this.loadGasCostsData();
    this.loadConsumptionAndCostData();
    this.loadCostAnalysisData();

    // Set max year date for year pickers
    this.setMaxYearDate();
  }

  ngOnDestroy(): void {
    this.extractionCompletedSubscription?.unsubscribe();
    this.fileExtractionService.stopCheckingExtractionStatus();
  }

  populateLocationsDropdown() {
    this.locationsDropdownOptions = [this.allLocationsTranslation];

    const currentSelection = this.selectedLocationDropdown;

    if (this.selectedLocationDropdown === undefined) {
      this.selectedLocationDropdown = 0;
    }

    for (let i = 0; i < this.listOfLocations.length; i++) {
      const location = this.listOfLocations[i];
      const locationString = `${location.street ?? ''} ${location.number ?? ''}, ${location.postal_code ?? ''} ${location.city ?? ''}`;
      this.locationsDropdownOptions.push(locationString);
    }

    if (currentSelection !== undefined && currentSelection > 0) {
      if (currentSelection > this.listOfLocations.length) {
        this.selectedLocationDropdown = 0;
      }
    }
  }

  loadLocationsData() {
    this.locationService.getLocations().subscribe({
      next: (response) => {
        if (response) {
          this.listOfLocations = response;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
        this.populateLocationsDropdown();
      }
    });
  }

  openComparisonYearSelect() {
    this.gasCostsComparisonDate = new Date();
    this.gasCostsComparisonDate.setFullYear(this.gasCostsComparisonDate.getFullYear() - 1);
    this.loadGasComparisonCostsData();
  }

  loadGasCostsData() {
    if (this.gasCostsDate?.getFullYear() === null || this.gasCostsDate?.getFullYear() === undefined) {
      this.gasCostsDate = new Date();
    }

    this.gasCostsDataYear = this.gasCostsDate?.getFullYear();
    const location = (this.selectedLocationDropdown === 0) ? null : this.listOfLocations[(this.selectedLocationDropdown! - 1)].id;
    this.dashboardService.getGasOverview(this.gasCostsDataYear, location).subscribe({
      next: (response) => {
        if (response) {
          this.gasCostsDataResponse = response;

          // Populate charts
          this.populateGasCostsData();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.gasCostsDataLoaded = false;

        // Populate charts
        this.populateGasCostsData();
      },
      complete: () => {
        // Mark api loading as completed
        this.gasCostsDataLoaded = true;
      }
    });
  }

  populateGasCostsData(): void {
    this.averagePricePerSmcData = new Array(12).fill(null);
    this.invoiceAmountActualData = new Array(12).fill(0);
    this.invoiceAmountForecastData = new Array(12).fill(0);
    this.forecastedStartMonth = null;

    if (!this.gasCostsDataResponse ||
      !this.gasCostsDataResponse.total_costs.length ||
      !this.gasCostsDataResponse.total_consumption.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const dataYear = this.gasCostsDataYear;

    this.gasCostsDataResponse.total_costs.forEach(monthData => {
      const monthIndex = monthData.month - 1;

      if (dataYear < currentYear || (dataYear === currentYear && monthData.month < currentMonth)) {
        this.invoiceAmountActualData[monthIndex] = monthData.actual_value ?? 0;

      } else {
        this.invoiceAmountForecastData[monthIndex] = monthData.forecasted_value ?? 0;
      }
    });

    this.gasCostsDataResponse.total_consumption.forEach(monthData => {
      const monthIndex = monthData.month - 1;

      const actualCost = this.invoiceAmountActualData[monthIndex] ?? 0;
      const forecastCost = this.invoiceAmountForecastData[monthIndex] ?? 0;
      const actualConsumption = monthData.actual_value ?? 0;
      const forecastConsumption = monthData.forecasted_value ?? 0;

      if (dataYear < currentYear || (dataYear === currentYear && monthData.month < currentMonth)) {
        // Actual average price per Smc
        this.averagePricePerSmcData[monthIndex] =
          actualCost > 0 && actualConsumption > 0
            ? actualCost / actualConsumption
            : null;
      } else {
        if (this.forecastedStartMonth === null) {
          this.forecastedStartMonth = monthIndex;
        }
        // Forecasted values for current and future months
        this.averagePricePerSmcData[monthIndex] =
          forecastCost > 0 && forecastConsumption > 0
            ? forecastCost / forecastConsumption
            : null;
      }
    });

    this.noDataDialogShowCosts = [
      ...this.invoiceAmountActualData,
      ...this.invoiceAmountForecastData,
      ...this.averagePricePerSmcData
    ].every(value => value === 0 || value === null);
    this.populateComparisonCurrent();
  }

  populateComparisonCurrent(): void {
    this.compariosonCurrentyear = this.gasCostsDataYear;
    this.compariosonCurrentlastFullMonthCost = 0;
    this.compariosonCurrentlastFullMonthSmc = 0;
    this.compariosonCurrentyearToDateCost = 0;
    this.compariosonCurrentyearToDateSmc = 0;
    this.compariosonCurrentforecastFullYearCost = 0;
    this.compariosonCurrentforecastFullYearSmc = 0;

    if (!this.gasCostsDataResponse ||
      !this.gasCostsDataResponse.total_costs.length ||
      !this.gasCostsDataResponse.total_consumption.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    let lastFullMonthIndexComparison = currentMonth - 1;

    // Jan remains Jan
    if (lastFullMonthIndexComparison < 1) {
      lastFullMonthIndexComparison = 1;
    }

    this.gasCostsDataResponse.total_costs.forEach((monthData) => {
      const monthIndex = monthData.month;

      const actualCost = monthData.actual_value ?? 0;
      const forecastCost = monthData.forecasted_value ?? 0;

      if (monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonCurrentyearToDateCost += actualCost;
      }

      if (this.compariosonCurrentyear < currentYear || monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonCurrentforecastFullYearCost += actualCost;
      } else {
        this.compariosonCurrentforecastFullYearCost += forecastCost;
      }
    });

    this.gasCostsDataResponse.total_consumption.forEach((monthData) => {
      const monthIndex = monthData.month;

      const actualSmc = monthData.actual_value ?? 0;
      const forecastSmc = monthData.forecasted_value ?? 0;

      if (monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonCurrentyearToDateSmc += actualSmc;
      }

      if (this.compariosonCurrentyear < currentYear || monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonCurrentforecastFullYearSmc += actualSmc;
      } else {
        this.compariosonCurrentforecastFullYearSmc += forecastSmc;
      }

      if (monthIndex === lastFullMonthIndexComparison) {
        this.compariosonCurrentlastFullMonthCost = this.gasCostsDataResponse?.total_costs[monthIndex - 1]?.actual_value ?? 0;
        this.compariosonCurrentlastFullMonthSmc = this.gasCostsDataResponse?.total_consumption[monthIndex - 1]?.actual_value ?? 0;
      }
    });
  }

  loadGasComparisonCostsData() {
    if (this.gasCostsComparisonDate?.getFullYear() === null || this.gasCostsComparisonDate?.getFullYear() === undefined) {
      this.gasCostsComparisonDate = new Date();
    }

    this.gasCostsComparisonDataYear = this.gasCostsComparisonDate?.getFullYear();
    const location = (this.selectedLocationDropdown === 0) ? null : this.listOfLocations[(this.selectedLocationDropdown! - 1)].id;
    this.dashboardService.getGasOverview(this.gasCostsComparisonDataYear, location).subscribe({
      next: (response) => {
        if (response) {
          this.gasCostsComparisonDataResponse = response;

          // Populate charts
          this.populateComparison();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.gasCostsComparisonDataLoaded = false;

        // Populate charts
        this.populateComparison();
      },
      complete: () => {
        // Mark api loading as completed
        this.gasCostsComparisonDataLoaded = true;
      }
    });
  }

  locationChange() {
    this.loadGasCostsData();
    this.loadGasComparisonCostsData()
  }

  populateComparison(): void {
    this.compariosonOlderyear = this.gasCostsComparisonDataYear;
    this.compariosonOlderlastFullMonthCost = 0;
    this.compariosonOlderlastFullMonthSmc = 0;
    this.compariosonOlderyearToDateCost = 0;
    this.compariosonOlderyearToDateSmc = 0;
    this.compariosonOlderforecastFullYearCost = 0;
    this.compariosonOlderforecastFullYearSmc = 0;

    if (!this.gasCostsComparisonDataResponse ||
      !this.gasCostsComparisonDataResponse.total_costs.length ||
      !this.gasCostsComparisonDataResponse.total_consumption.length) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    let lastFullMonthIndexComparison = currentMonth - 1;

    // Jan remains Jan
    if (lastFullMonthIndexComparison < 1) {
      lastFullMonthIndexComparison = 1;
    }

    this.gasCostsComparisonDataResponse.total_costs.forEach((monthData) => {
      const monthIndex = monthData.month;

      const actualCost = monthData.actual_value ?? 0;
      const forecastCost = monthData.forecasted_value ?? 0;

      if (monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonOlderyearToDateCost += actualCost;
      }

      if (this.compariosonOlderyear < currentYear || monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonOlderforecastFullYearCost += actualCost;
      } else {
        this.compariosonOlderforecastFullYearCost += forecastCost;
      }
    });

    this.gasCostsComparisonDataResponse.total_consumption.forEach((monthData) => {
      const monthIndex = monthData.month;

      const actualSmc = monthData.actual_value ?? 0;
      const forecastSmc = monthData.forecasted_value ?? 0;

      if (monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonOlderyearToDateSmc += actualSmc;
      }

      if (this.compariosonOlderyear < currentYear || monthIndex <= lastFullMonthIndexComparison) {
        this.compariosonOlderforecastFullYearSmc += actualSmc;
      } else {
        this.compariosonOlderforecastFullYearSmc += forecastSmc;
      }

      if (monthIndex === lastFullMonthIndexComparison) {
        this.compariosonOlderlastFullMonthCost = this.gasCostsComparisonDataResponse!.total_costs[monthIndex - 1]?.actual_value ?? 0;
        this.compariosonOlderlastFullMonthSmc = this.gasCostsComparisonDataResponse!.total_consumption[monthIndex - 1]?.actual_value ?? 0;
      }
    });
  }

  loadConsumptionAndCostData() {
    if (this.consumptionAndCostsDate?.getFullYear() === null || this.consumptionAndCostsDate?.getFullYear() === undefined) {
      this.consumptionAndCostsDate = new Date();
    }

    this.consumptionAndCostsDataYear = this.consumptionAndCostsDate?.getFullYear();
    this.dashboardService.getGasConsumptionAndCosts(this.consumptionAndCostsDataYear).subscribe({
      next: (response) => {
        if (response) {
          this.consumptionAndCostsDataResponse = response;

          // Populate charts
          this.populateConsumptionAndCosts();
          this.populateQuarterData();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.consumptionAndCostsDataLoaded = false;

        // Populate charts
        this.populateConsumptionAndCosts();
        this.populateQuarterData();
      },
      complete: () => {
        // Mark api loading as completed
        this.consumptionAndCostsDataLoaded = true;
      }
    });
  }

  populateConsumptionAndCosts(): void {
    this.cacl_consumption = new Array(12).fill(null);
    this.cacl_consumptionForecasted = new Array(12).fill(null);
    this.cacl_costsPerSmc = new Array(12).fill(null);
    this.cacl_totalCost = new Array(12).fill(null);
    this.cacl_costsPerSmcForecastedStartMonth = null;
    this.cacl_totalCostForecastedStartMonth = null;

    if (!this.consumptionAndCostsDataResponse || !this.consumptionAndCostsDataResponse.yearly_overview) {
      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    this.consumptionAndCostsDataResponse.yearly_overview.total_consumption.forEach((monthData) => {
      const monthIndex = monthData.month - 1;

      const actualConsumption = monthData.actual_value ?? null;
      const forecastedConsumption = monthData.forecasted_value ?? 0;

      if (this.consumptionAndCostsDataYear < currentYear || monthData.month < currentMonth) {
        this.cacl_consumption[monthIndex] = actualConsumption;

      } else {
        this.cacl_consumptionForecasted[monthIndex] = forecastedConsumption;
      }
    });

    this.consumptionAndCostsDataResponse.yearly_overview.total_costs.forEach((monthData) => {
      const monthIndex = monthData.month - 1;

      const actualCost = monthData.actual_value ?? 0;
      const forecastedCost = monthData.forecasted_value ?? 0;

      if (this.consumptionAndCostsDataYear < currentYear || monthData.month < currentMonth) {
        this.cacl_totalCost[monthIndex] = actualCost;
      } else {
        if (this.cacl_totalCostForecastedStartMonth === null) {
          this.cacl_totalCostForecastedStartMonth = monthIndex;
        }
        this.cacl_totalCost[monthIndex] = forecastedCost;
      }
    });

    for (let i = 0; i < 12; i++) {
      if (this.cacl_consumption[i] !== null && this.cacl_consumption[i]! > 0) {
        this.cacl_costsPerSmc[i] = parseFloat((this.cacl_totalCost[i]! / this.cacl_consumption[i]!).toFixed(4));
      }
    }

    const allValues = [
      ...this.cacl_consumption,
      ...this.cacl_consumptionForecasted,
      ...this.cacl_totalCost,
      ...this.cacl_costsPerSmc
    ];

    this.noDataDialogShowConsumptionCosts = allValues.every(value => value === null || value === 0);
  }

  populateQuarterData(): void {
    this.smcQuarterData = [0, 0, 0, 0];

    if (!this.consumptionAndCostsDataResponse || !this.consumptionAndCostsDataResponse.quarter_data.length) {
      return;
    }

    this.consumptionAndCostsDataResponse.quarter_data.forEach((quarter) => {
      const quarterIndex = quarter.quarter_number - 1;
      if (quarterIndex >= 0 && quarterIndex < 4) {
        this.smcQuarterData[quarterIndex] = quarter.total_consumption ?? 0;
      }
    });
  }

  openMonthSelect() {
    this.costAnalysisMonth = new Date();
    this.changeMonth();
  }

  changeMonth() {
    if (this.costAnalysisMonth === undefined || this.costAnalysisYear === undefined) {
      return;
    }

    if (this.costAnalysisMonth.getFullYear() !== this.costAnalysisYear.getFullYear()) {
      this.costAnalysisYear = new Date(this.costAnalysisMonth.getFullYear(), this.costAnalysisYear.getMonth());
    }

    this.loadCostAnalysisData();
  }

  loadCostAnalysisCurrentPeriodData() {
    // Year
    if (this.costAnalysisYear?.getFullYear() === null || this.costAnalysisYear?.getFullYear() === undefined) {
      this.costAnalysisYear = new Date();
    }

    this.costAnalysisDataYear = this.costAnalysisYear?.getFullYear();

    // Month
    if (this.costAnalysisMonth === undefined) {
      this.costAnalysisDataMonth = null;
    }
    else {
      this.costAnalysisDataMonth = this.costAnalysisMonth?.getMonth() + 1;
    }

    this.dashboardService.getGasPeriodCostAnalysis(this.costAnalysisDataYear, this.costAnalysisDataMonth).subscribe({
      next: (response) => {
        if (response) {
          this.costAnalysisDataResponse = response;

          // Populate charts
          this.populateCostAnalysisPeriodTrend();
          this.populateCostPerSmcChart();
          this.populateCostBreakdownChart();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.costAnalysisDataLoaded = false;

        // Populate charts
        this.populateCostAnalysisPeriodTrend();
        this.populateCostPerSmcChart();
        this.populateCostBreakdownChart();
      },
      complete: () => {
        // Mark api loading as completed
        this.costAnalysisDataLoaded = true;
      }
    });
  }

  loadCostAnalysisPervoiusPeriodData() {
    // Year
    if (this.costAnalysisYear?.getFullYear() === null || this.costAnalysisYear?.getFullYear() === undefined) {
      this.costAnalysisYear = new Date();
    }

    this.costAnalysisPervoiusPeriodDataYear = this.costAnalysisYear?.getFullYear() - 1;

    // Month
    if (this.costAnalysisMonth === undefined) {
      this.costAnalysisDataMonth = null;
    }
    else {
      this.costAnalysisPervoiusPeriodDataMonth = this.costAnalysisMonth?.getMonth() + 1;
    }

    this.dashboardService.getGasPeriodCostAnalysis(this.costAnalysisPervoiusPeriodDataYear, this.costAnalysisPervoiusPeriodDataMonth).subscribe({
      next: (response) => {
        if (response) {
          this.costAnalysisPervoiusPeriodDataResponse = response;

          // Populate charts
          this.populateCostAnalysisPeriodTrend();
          this.populateCostPerSmcChart();
          this.populateCostBreakdownChart();
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';
        var showError = true;

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
          if (error.error.code == 'SVC-4303') {
            showError = false;
          }
        }

        if (showError) {
          this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
        }
        this.costAnalysisPervoiusPeriodDataLoaded = false;

        // Populate charts
        this.populateCostAnalysisPeriodTrend();
        this.populateCostPerSmcChart();
        this.populateCostBreakdownChart();

      },
      complete: () => {
        // Mark api loading as completed
        this.costAnalysisPervoiusPeriodDataLoaded = true;
      }
    });
  }

  loadCostAnalysisData() {
    if (this.costAnalysisMonth != undefined && this.costAnalysisYear != undefined && this.costAnalysisMonth.getFullYear() !== this.costAnalysisYear.getFullYear()) {
      this.costAnalysisMonth = new Date(this.costAnalysisYear.getFullYear(), this.costAnalysisMonth.getMonth());
    }

    this.loadCostAnalysisCurrentPeriodData();
    this.loadCostAnalysisPervoiusPeriodData();
  }

  populateCostAnalysisPeriodTrend(): void {
    this.capd_lineCostTrendData = [0, 0];
    this.capd_barSmcData = [0, 0];
    this.capd_inputedPeriods = undefined;

    if (!this.costAnalysisDataResponse || !this.costAnalysisPervoiusPeriodDataResponse) {
      return;
    }

    this.capd_inputedPeriods = [
      this.getPeriodString(this.costAnalysisPervoiusPeriodDataYear, this.costAnalysisPervoiusPeriodDataMonth),
      this.getPeriodString(this.costAnalysisDataYear, this.costAnalysisDataMonth)
    ];

    const currentTotalCost = this.costAnalysisDataResponse.total_cost ?? 0;
    const previousTotalCost = this.costAnalysisPervoiusPeriodDataResponse.total_cost ?? 0;

    const currentTotalSmc = this.costAnalysisDataResponse.total_consumption ?? 0;
    const previousTotalSmc = this.costAnalysisPervoiusPeriodDataResponse.total_consumption ?? 0;

    this.capd_lineCostTrendData = [parseFloat(previousTotalCost.toFixed(2)), parseFloat(currentTotalCost.toFixed(2))];
    this.capd_barSmcData = [parseFloat(previousTotalSmc.toFixed(2)), parseFloat(currentTotalSmc.toFixed(2))];

    this.capd_SmcDifference = parseFloat((currentTotalSmc - previousTotalSmc).toFixed(2));
    this.capd_costDifference = parseFloat((currentTotalCost - previousTotalCost).toFixed(2));
  }

  getPeriodString(year: number, month: number | null): string {
    return month ? `${this.months[month - 1]} ${year}` : `${year}`;
  }

  populateCostPerSmcChart(): void {
    this.materialCostsDifferenceSign = '+';
    this.materialCostsDifference = 0;
    this.fixedCostsDifferenceSign = '+';
    this.fixedCostsDifference = 0;
    this.tmsDifferenceSign = '+';
    this.tmsDifference = 0;
    this.additionalChargesDifferenceSign = '+';
    this.additionalChargesDifference = 0;
    this.taxesDifferenceSign = '+';
    this.taxesDifference = 0;
    this.previousPeriodCostPerSmc = 0;
    this.currentPeriodCostPerSmc = 0;
    this.inputedPeriods = undefined;

    if (!this.costAnalysisDataResponse || !this.costAnalysisPervoiusPeriodDataResponse) {
      this.noDataPopUp = true;
      return;
    }

    this.inputedPeriods = [
      this.getPeriodString(this.costAnalysisPervoiusPeriodDataYear, this.costAnalysisPervoiusPeriodDataMonth),
      this.getPeriodString(this.costAnalysisDataYear, this.costAnalysisDataMonth)
    ];

    const currentTotalSmc = this.costAnalysisDataResponse.total_consumption ?? 0;
    const previousTotalSmc = this.costAnalysisPervoiusPeriodDataResponse.total_consumption ?? 0;
    const currentTotalCost = this.costAnalysisDataResponse.total_cost ?? 0;
    const previousTotalCost = this.costAnalysisPervoiusPeriodDataResponse.total_cost ?? 0;

    this.previousPeriodCostPerSmc = previousTotalSmc > 0 ? parseFloat((previousTotalCost / previousTotalSmc).toFixed(4)) : 0;
    this.currentPeriodCostPerSmc = currentTotalSmc > 0 ? parseFloat((currentTotalCost / currentTotalSmc).toFixed(4)) : 0;

    // Material Costs
    const currentMaterialCosts = (this.costAnalysisDataResponse.material_costs_gas_fixed_calc ?? 0) + (this.costAnalysisDataResponse.material_costs_gas_variable_calc ?? 0);
    const previousMaterialCosts = (this.costAnalysisPervoiusPeriodDataResponse.material_costs_gas_fixed_calc ?? 0) + (this.costAnalysisPervoiusPeriodDataResponse.material_costs_gas_variable_calc ?? 0);

    this.materialCostsDifference = previousMaterialCosts > 0 ? parseFloat((currentMaterialCosts - previousMaterialCosts).toFixed(2)) : 0;

    // Fixed Costs
    const currentFixedCosts = this.costAnalysisDataResponse.fixed_charge ?? 0;
    const previousFixedCosts = this.costAnalysisPervoiusPeriodDataResponse.fixed_charge ?? 0;
    this.fixedCostsDifference = previousFixedCosts > 0 ? parseFloat((currentFixedCosts - previousFixedCosts).toFixed(2)) : 0;

    // TMS
    const currentTms = this.costAnalysisDataResponse.tms_costs ?? 0;
    const previousTms = this.costAnalysisPervoiusPeriodDataResponse.tms_costs ?? 0;
    this.tmsDifference = previousTms > 0 ? parseFloat((currentTms - previousTms).toFixed(2)) : 0;

    // Additional Charges
    const currentAdditionalCharges = this.costAnalysisDataResponse.additional_charges ?? 0;
    const previousAdditionalCharges = this.costAnalysisPervoiusPeriodDataResponse.additional_charges ?? 0;
    this.additionalChargesDifference = previousAdditionalCharges > 0 ? parseFloat((currentAdditionalCharges - previousAdditionalCharges).toFixed(2)) : 0;

    // Taxes
    const currentTaxes = this.costAnalysisDataResponse.total_taxes ?? 0;
    const previousTaxes = this.costAnalysisPervoiusPeriodDataResponse.total_taxes ?? 0;
    this.taxesDifference = previousTaxes > 0 ? parseFloat((currentTaxes - previousTaxes).toFixed(2)) : 0;

    this.materialCostsDifferenceSign = this.materialCostsDifference >= 0 ? '+' : '-';
    this.fixedCostsDifferenceSign = this.fixedCostsDifference >= 0 ? '+' : '-';
    this.tmsDifferenceSign = this.tmsDifference >= 0 ? '+' : '-';
    this.additionalChargesDifferenceSign = this.additionalChargesDifference >= 0 ? '+' : '-';
    this.taxesDifferenceSign = this.taxesDifference >= 0 ? '+' : '-';

    this.materialCostsDifference = Math.abs(this.materialCostsDifference);
    this.fixedCostsDifference = Math.abs(this.fixedCostsDifference);
    this.tmsDifference = Math.abs(this.tmsDifference);
    this.additionalChargesDifference = Math.abs(this.additionalChargesDifference);
    this.taxesDifference = Math.abs(this.taxesDifference);

    // Show no data popup
    if (this.previousPeriodCostPerSmc == 0 || this.currentPeriodCostPerSmc == 0) {
      this.noDataPopUp = true;
    }
    else {
      this.noDataPopUp = false;
    }
  }

  populateCostBreakdownChart(): void {
    this.costBreakdownData = new Array(5).fill(0);
    this.totalPricePerUnit = 0;
    let totalCost = 0;
    let totalSmc = 0;
    let totalPricePerUnit = 0;

    if (!this.costAnalysisDataResponse) {
      return;
    }

    totalCost = this.costAnalysisDataResponse.total_cost ?? 0;
    totalSmc = this.costAnalysisDataResponse.total_consumption ?? 0;

    if (totalSmc === 0 || totalCost === 0) {
      return;
    }

    const materialCOsts = ((this.costAnalysisDataResponse.material_costs_gas_fixed_calc ?? 0) + (this.costAnalysisDataResponse.material_costs_gas_variable_calc ?? 0)) / totalSmc;
    const fixedCosts = (this.costAnalysisDataResponse.fixed_charge ?? 0) / totalSmc;
    const tmsCosts = (this.costAnalysisDataResponse.tms_costs ?? 0) / totalSmc;
    const additionalCharges = (this.costAnalysisDataResponse.additional_charges ?? 0) / totalSmc;
    const taxesCosts = (this.costAnalysisDataResponse.total_taxes ?? 0) / totalSmc;

    this.costBreakdownData = [
      parseFloat(materialCOsts.toFixed(2)),
      parseFloat(fixedCosts.toFixed(2)),
      parseFloat(tmsCosts.toFixed(2)),
      parseFloat(additionalCharges.toFixed(2)),
      parseFloat(taxesCosts.toFixed(2))
    ];

    if (totalSmc > 0) {
      totalPricePerUnit = parseFloat((totalCost / totalSmc).toFixed(2));
    }

    this.totalPricePerUnit = totalPricePerUnit;
  }

  setMaxYearDate() {
    if (this.showUpgradeGeneral) {
      return;
    }

    this.dashboardService.getGasLatestForecastInvoice().subscribe({
      next: (response) => {
        this.gasForecastMaxDate.setFullYear(
          response.year
        );
      },
      error: async (error) => {
        this.gasForecastMaxDate.setFullYear(
          this.gasForecastMaxDate.getFullYear() + 1
        );
      }
    });
  }
}
